<template>
    <div class="popup-attention">
        <div class="popup-attention__content">
            <h2 class="popup-attention__title-big">
                Внимание!
            </h2>
            <h3 class="popup-attention__title popup__title">
                Конкурс завершен, но&nbsp;вы&nbsp;все еще можете пройти этот увлекательный тест на&nbsp;знание истории компьютерной игры серии FIFA.
            </h3>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'Attention',
    }
</script>



// WEBPACK FOOTER //
// Attention.vue?28e20536